/**
 * This file is a copy from mweb
 */
import { useEffect } from 'react'
import { useHydrationDone } from './useHydrationDone'

export function useScrollIntoView(
  effectDependency: boolean,
  ref: React.RefObject<any> | undefined,
  delay: number,
) {
  const isDone = useHydrationDone()

  useEffect(() => {
    if (effectDependency && isDone) {
      const timer = setTimeout(() => {
        if (ref && ref.current && ref.current.scrollIntoView) {
          ref.current.scrollIntoView({ behavior: 'smooth' })
        } else {
          clearTimeout(timer)
        }
      }, delay)

      return () => clearTimeout(timer)
    }
  }, [effectDependency, isDone])
}
